import React from 'react';
import { Zap, Layers, Eye, TrendingDown } from 'lucide-react';
import { whyPryshContent } from '../data/mock';

const iconMap = {
  1: Zap,
  2: Layers,
  3: Eye,
  4: TrendingDown
};

const WhyPryshSection = () => {
  return (
    <section id="why-prysh" className="relative bg-[#121212] py-32 overflow-hidden">
      {/* Grid Background */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 100px),
            repeating-linear-gradient(-90deg, rgba(255,255,255,0.2), rgba(255,255,255,0.2) 1px, transparent 1px, transparent 100px)
          `,
          backgroundSize: '100px 100px'
        }}
      />

      {/* Accent orbs */}
      <div className="absolute left-0 top-1/3 w-[400px] h-[400px] bg-[#00FFD1]/5 rounded-full blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-[7.6923%]">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-[#00FFD1] text-lg font-medium tracking-wide">Advantages</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-white leading-tight mt-4">
            {whyPryshContent.title}
          </h2>
          <p className="text-2xl text-white/60 mt-4">
            {whyPryshContent.subtitle}
          </p>
        </div>

        {/* Value Pillars */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyPryshContent.pillars.map((pillar) => {
            const IconComponent = iconMap[pillar.id];
            return (
              <div
                key={pillar.id}
                className="group relative bg-black border border-white/10 p-8 hover:border-[#00FFD1]/40 transition-all duration-400 overflow-hidden"
              >
                {/* Large background metric */}
                <div className="absolute -bottom-4 -right-2 text-[100px] font-bold text-white/[0.03] leading-none select-none">
                  {pillar.metric}
                </div>
                
                {/* Hover glow */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#00FFD1]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />

                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-12 h-12 bg-[#00FFD1]/10 flex items-center justify-center mb-6 group-hover:bg-[#00FFD1]/20 transition-colors duration-400">
                    <IconComponent className="w-6 h-6 text-[#00FFD1]" />
                  </div>

                  {/* Metric */}
                  <div className="mb-4">
                    <span className="text-4xl md:text-5xl font-bold text-[#00FFD1]">
                      {pillar.metric}
                    </span>
                    <p className="text-white/40 text-sm mt-1">{pillar.metricLabel}</p>
                  </div>

                  {/* Title & Description */}
                  <h3 className="text-2xl font-semibold text-white mb-2">
                    {pillar.title}
                  </h3>
                  <p className="text-white/50 leading-relaxed">
                    {pillar.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyPryshSection;
